
import React from "react";
import { Button } from "../../components/ui/button";
import { ChartBar, Upload, Brain } from "lucide-react";

interface ActionButtonsProps {
  onOpenRatiosDrawer: () => void;
  onOpenOnePager: () => void;
  onOpenUploadModal: () => void;
  financialData?: any;
  customerId?:string | ""
  ratioActionButton?:string 
  loading?:boolean
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ 
  onOpenRatiosDrawer, 
  onOpenOnePager,
  onOpenUploadModal,
  financialData,
  customerId,
  ratioActionButton,
  loading
}) => {

 
  return (
    <div className="flex justify-end gap-3 animate-fade-in">
      <Button 
      
        variant="outline"
        className="flex items-center gap-2 border-green-300 text-green-700 hover:bg-green-100 
                  hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md"
        onClick={onOpenUploadModal}
      >
        <Upload className="h-4 w-4 transition-transform group-hover:scale-110" />
        <span>Upload Financials</span>
      </Button>
      
      <Button 
        disabled= {loading}
        variant="outline"
        className="flex items-center gap-2 border-purple-300 text-purple-700 hover:bg-purple-100 
                  hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md"
        onClick={onOpenRatiosDrawer}
      >
        {loading && ( <div className="h-5 w-5 border-2 border-[#9E7926] border-t-transparent rounded-full animate-spin" />)}
        {ratioActionButton == 'AFIN Overview' || ratioActionButton == 'Regenerate AFIN Overview' ? (
          <Brain className="h-4 w-4 transition-transform group-hover:scale-110" />
          ) : 
          <ChartBar className="h-4 w-4 transition-transform group-hover:scale-110" />
          }
        <span>{ratioActionButton}</span>
      </Button>
      
      {/* <Button 
        variant="outline"
        className="flex items-center gap-2 border-blue-300 text-blue-700 hover:bg-blue-100 
                  hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md"
        onClick={onOpenOnePager}
      >
        <FileText className="h-4 w-4 transition-transform group-hover:scale-110" />
        <span>Generate One-Pager</span>
      </Button> */}
    </div>
  );
};

export default ActionButtons;
